import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { translationChunksConfig } from "@spartacus/assets";
import { I18nModule, ConfigModule, CmsConfig, provideConfig } from "@spartacus/core";
import { provideOutlet, OutletPosition } from "@spartacus/storefront";
import { CreateNewTicketComponent } from "./create-new-ticket/create-new-ticket.component";
import { CustomerServicePageComponent } from "./customer-service-page/customer-service-page.component";
import { TicketDetailsComponent } from "./ticket-details/ticket-details.component";
import { TicketHistoryPageComponent } from "./ticket-history-page/ticket-history-page.component";

@NgModule({
  declarations: [CreateNewTicketComponent, CustomerServicePageComponent, TicketDetailsComponent, TicketHistoryPageComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        TicketHistoryComponent: {
          component: TicketHistoryPageComponent,
        },
      },
    } as CmsConfig),
  ],

  providers: [
    provideOutlet({
      id: 'CustomerService-left',
      position: OutletPosition.REPLACE,
      component: CustomerServicePageComponent,
    }),
  ]}
)
export class CustomCustomerServiceBrModule { }
